import {
  SET_TTG_GAME_NAMES,
  SET_TTG_GAME_IMAGES,
  SET_TTG_GAME_POLA,
  SET_GAME_ISLOADING,
  SET_GAME_ISERROR
} from '../actionTypes';
import { mainAxios } from '../../apis/axios';

const cheerio = require("cheerio");
const now = new Date();
const betForPola = ["10", "20", "30", "50", "70", "100", "500", "1000"];

export const setTTGGameNames = (payload) => {
  return {
    type: SET_TTG_GAME_NAMES,
    payload: payload
  };
};

export const setTTGGameImages = (payload) => {
  return {
    type: SET_TTG_GAME_IMAGES,
    payload: payload
  };
};

export const setTTGPolas = (payload) => {
  return {
    type: SET_TTG_GAME_POLA,
    payload: payload
  };
};

export const setGameIsLoading = (payload) => {
  return {
    type: SET_GAME_ISLOADING,
    payload: payload
  };
};

export const setGameIsError = (payload) => {
  return {
    type: SET_GAME_ISERROR,
    payload: payload
  };
};

export const fetchTTGGamesData = () => {
  return async (dispatch) => {
    dispatch(setGameIsLoading(true));
    await mainAxios(
      {
        method: 'GET',
        url: '/api/?content=slot&provider=ttg'
      }
    )
      .then(({ data }) => {
        const $ = cheerio.load(data);
        const check = $('.gameitem');
        let tempTTGName = [];
        let tempTTGImg = [];
        for (let i = 0; i < check.length; i++) {
          let nameTTGGame = $(check[i]).find('figcaption').text();
          let imageTTGGame = $(check[i]).find('img').attr('src');
          tempTTGName.push(nameTTGGame);
          tempTTGImg.push(imageTTGGame);
        }
        dispatch(setTTGGameNames(tempTTGName));
        dispatch(setTTGGameImages(tempTTGImg));
      })
      .catch(err => {
        dispatch(setGameIsError(err));
      })
      .finally(() => {
        dispatch(setGameIsLoading(false));
      });
  };
};

export const fetchTTGPolasData = () => {
  return async (dispatch) => {
    dispatch(setGameIsLoading(true));
    await mainAxios(
      {
        method: 'GET',
        url: '/getTtgPolas'
      }
    )
      .then(({ data }) => {
        for (let i = 0; i < 1000; i++) {
          let value1 = `${betForPola[Math.floor(Math.random() * 8)]}`
          let value2 = `${betForPola[Math.floor(Math.random() * 8)]}`
          let value3 = `${betForPola[Math.floor(Math.random() * 8)]}`
          if (!data[i]) {
            mainAxios(
              {
                method: 'POST',
                url: '/postTtgPola',
                data: {
                  value1: value1,
                  value2: value2,
                  value3: value3
                }
              }
            )
              .then(() => {
                console.log('New Pola added!');
              })
              .catch(err => {
                dispatch(setGameIsError(err));
              })
          } else if (data[i].value1 === null || data[i].value2 === null || data[i].value3 === null) {
            mainAxios(
              {
                method: 'PUT',
                url: '/updateTtgPola/' + data[i].id,
                data: {
                  value1: value1,
                  value2: value2,
                  value3: value3,
                  updatedAt: now.toISOString()
                }
              }
            )
              .then(() => {
                console.log('Pole baru saja diupdate');
              })
              .catch(err => {
                dispatch(setGameIsError(err));
              })
          } else if (now.getDate() + now.getHours() !== (new Date(data[i].updatedAt).getDate()) + (new Date(data[i].updatedAt).getHours())) {
            mainAxios(
              {
                method: 'PUT',
                url: '/updateTtgPola/' + data[i].id,
                data: {
                  value1: value1,
                  value2: value2,
                  value3: value3,
                  updatedAt: now.toISOString()
                }
              }
            )
              .then(() => {
                console.log('Pole baru saja diupdate');
              })
              .catch(err => {
                dispatch(setGameIsError(err));
              })
          } else {
            console.log('Pola is up to date');
          }
        }
        mainAxios(
          {
            method: 'GET',
            url: '/getTtgPolas'
          }
        )
          .then(({ data }) => {
            dispatch(setTTGPolas(data));
          })
      })
      .catch(err => {
        dispatch(setGameIsError(err));
      })
      .finally(() => {
        dispatch(setGameIsLoading(false));
      });
  };
};